const types = {
    FETCH_VERSION_HISTORY_START: "FETCH_VERSION_HISTORY_START",
    FETCH_VERSION_HISTORY_SUCCESS: "FETCH_VERSION_HISTORY_SUCCESS",
    FETCH_VERSION_HISTORY_ERROR: "FETCH_VERSION_HISTORY_ERROR",
}

export default types;